<!-- CLIENT -->
<div class="card formula-card" *ngIf="type === 'CLIENT'">

    <h4 class="section-title" style="margin-top: -0.5rem;">
        📊 Compliance Action %
    </h4>

    <div class="formula-box">
        <strong>Formula</strong>
        <p>
            (Total No. of Compliance Submitted) /
            (Total No. of Compliances Supposed to be Submitted till Date) × 100
        </p>
    </div>

    <ol class="detail-list">
        <li>
            <span class="badge badge-a">A</span>
            <strong>Total No. of Compliance Submitted</strong>
            <p class="sub-text">
                Late Closure + On Time + Not Applicable + Pending Approval
            </p>
        </li>

        <li>
            <span class="badge badge-b">B</span>
            <strong>Total No. of Compliances Supposed to be Submitted till Date</strong>
            <p class="sub-text">
                Late Closure + On Time + Not Applicable + Non Compliance + Pending Approval
            </p>
        </li>

        <li class="highlight-result">
            Compliance Action % = <strong>(A / B) × 100</strong>
        </li>
    </ol>
</div>

<!-- SCORING -->
<div class="card formula-card" *ngIf="type === 'SCORING'">

    <h4 class="section-title" style="margin-top: -0.5rem;">
        📈 Scoring Calculation
    </h4>

    <ol class="detail-list">
        <li>
            <strong>Total Compliances for selected period</strong>
            <p class="sub-text">
                For the Company, Department and Location combination
            </p>
        </li>

        <li>
            <strong>Total Non Compliances for selected period</strong>
            <p class="sub-text">
                For the Company, Department and Location combination
            </p>
        </li>

        <li>
            <strong>Imprisonment Exposure</strong>
            <p class="sub-text">
                (Total No. of Non Compliance with Imprisonment) /
                (Total No. of Compliances with Imprisonment) × 100
            </p>
        </li>

        <li>
            <strong>License Cancellation Exposure</strong>
            <p class="sub-text">
                (Total No. of Non Compliance with License Cancellation) /
                (Total No. of Compliances with License Cancellation) × 100
            </p>
        </li>

        <li>
            <strong>Total Penalty Exposure</strong>
            <p class="sub-text">
                Sum of Maximum Penalty Amount of Total Compliances
            </p>
        </li>

        <li>
            <strong>Total Non Compliance Exposure</strong>
            <p class="sub-text">
                Sum of Maximum Penalty Amount of Non Compliances
            </p>
        </li>

        <li class="highlight-result">
            <strong>Total Penalty Paid</strong>
            <p class="sub-text">
                Sum of all Penalty / Interest Paid for Total Compliances
            </p>
        </li>
    </ol>
</div>

<!-- FOOTER -->
<div class="custom-dialog-footer" style="margin-top: -0.5rem;">
    <p-button class="w-full" label="Close" styleClass="customeclose" (click)="closemodel()">
    </p-button>
</div>